export default "__VITE_ASSET__C57Yo0xc__"